import mutations from './feuTreatmentReport.mutations'
import actions from './feuTreatmentReport.actions'
import getters from './feuTreatmentReport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
